export default {
  getBookingStatus(status) {
    if (status.handled) {
      return { status: 'handled', date: status.acceptedAt, option: status.acceptedOption };
    }
    if (status.acceptedAt) {
      return { status: 'accepted', date: status.acceptedAt, option: status.acceptedOption };
    }
    if (status.sentAt) {
      return { status: 'sent', date: status.sentAt };
    }
    return { status: 'processing', date: status.queuedAt };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/giftVoucher/helpers.js